import React from 'react';
import { Badge } from '@shopify/polaris';
import { certaintyTone, statusTone } from './routes';

export function CertaintyPill({ value }) {
  if (value == null) return <span>—</span>;
  return <Badge tone={certaintyTone(value)}>{String(value)}</Badge>;
}

export function StatusBadge({ status }) {
  return <Badge tone={statusTone(status)}>{status || 'none'}</Badge>;
}

// "Apparel & Accessories > Shoes" -> "Apparel & Accessories › Shoes" (last two levels), as the mockup shows paths.
export const leaf = (path) => (path ? path.split(' > ').slice(-2).join(' › ') : '—');
// The whole Shopify taxonomy path (Eric, 2026-10-26: the Review table shows the full proposed category).
export const fullPath = (path) => (path ? path.split(' > ').join(' › ') : '—');
